import {
  Box,
  Flex,
  Text
} from "@chakra-ui/react";
import React, { useEffect, useState, useMemo } from "react";
import FilterListContent from "./components/filterListContent";
import "./styles/list-commission.css";
import queryString from "query-string";
import { useLocation, useHistory } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import Pagination from "../order/components/pagination";
import { useDispatch, useSelector } from "react-redux";
import { fetchCommissionManagement } from "../../store/actions/commissionAction";
import { isEmpty } from "lodash";
import navguard from "../auth/navguard";
import { Link } from "react-router-dom";
import { DownloadIcon } from "./icons";
import { TotalCommissionActiveCommunityBanner } from "./components/TotalCommissionActiveCommunityBanner";
import Breadcrumb from "../common/breadcrumb";
import dateFormat from "dateformat";
import DownloadCommissionDetail from "./components/DownloadCommissionDetail";

function ListCommission() {
  const history = useHistory();
  const { search } = useLocation();
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();
  const { commissionManagement, commissionManagementMeta } = useSelector((state) => state.commission);
  const [dataCommission, setDataCommission] = useState([]);
  const totalPage = commissionManagementMeta.totalPage || 1;

  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { periodStart, periodEnd } = queryParams;

  useEffect(() => {
    if (!periodStart || !periodEnd) {
      const today = new Date();
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      
      const defaultPeriodStart = dateFormat(firstDayOfMonth, "yyyy-mm-dd");
      const defaultPeriodEnd = dateFormat(today, "yyyy-mm-dd");

      const updatedParams = {
        ...queryParams,
        periodStart: defaultPeriodStart,
        periodEnd: defaultPeriodEnd,
      };

      const newSearch = queryString.stringify(updatedParams);
      history.replace({ search: newSearch });
    }
  }, []);

  const detailCommissionUrl = (id) => {
    const currentQuery = queryString.parse(search);
    const params = {};
    
    if (currentQuery.periodEnd && currentQuery.periodStart) {
      params.periodEnd = currentQuery.periodEnd;
      params.periodStart = currentQuery.periodStart;
    }
    
    const queryParams = !isEmpty(params) ? `?${queryString.stringify(params)}` : "";
    return `/commission/detail-commission/${id}${queryParams}`;
  };

  const fetchData = () => {
    const today = new Date();
    const currentQuery = queryString.parse(search);
    if (!currentQuery.month && !currentQuery.year) {
      currentQuery.month = today.getMonth() + 1;
      currentQuery.year = today.getFullYear();
    } else if (!currentQuery.year) {
      currentQuery.year = today.getFullYear();
    } else if (!currentQuery.month) {
      currentQuery.month = today.getMonth() + 1;
    }

    dispatch(fetchCommissionManagement({
      ...currentQuery,
      limit: 10,
      page: +page + 1,
    }));
  };

  useEffect(() => {
    if (periodStart && periodEnd) {
      fetchData();
    }
  }, [search, page]);

  const formatter = (value) =>
    new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0,
      style: "currency",
      currency: "IDR",
    }).format(value);

  const columns = [
    {
      dataField: "communityCode",
      text: "Community Code",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{cell || "-"}</p>,
    },
    {
      dataField: "communityName",
      text: "Community Name",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{cell || "-"}</p>,
    },
    {
      dataField: "totalOrder",
      text: "Total Order Kumulatif",
      headerStyle: { fontWeight: "700", borderLeft: "1px solid #fff", height: "100%" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{formatter(cell || 0)}</p>,
    },
    {
      dataField: "commissionRate",
      text: "Commission Rate",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{cell || 0}%</p>,
    },
    {
      dataField: "totalCommission",
      text: "Total Commission",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{formatter(cell || 0)}</p>,
    },
    {
      dataField: "totalMember",
      text: "Total Member",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{cell || 0}</p>,
    },
    {
      dataField: "registeredDate",
      text: "Registered Date",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{!!cell ? dateFormat(cell, "dd / mm / yyyy") : "-"}</p>,
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: { fontWeight: "700" },
      formatter: (cell) => <p style={{ color: "#2A3D4A", marginBottom: 0 }}>{cell || "-"}</p>,
    },
    {
      dataField: "actions",
      style: { textAlign: "center" },
      formatter: (_, row) => (
        <Flex gap="12px">
          <DownloadCommissionDetail
            id={row.id}
            periodStart={periodStart}
            periodEnd={periodEnd}
            Trigger={({ onClick }) => (
              <Box cursor="pointer" padding="8px" backgroundColor="#fff" borderRadius="2px" border="1px solid #215AA8" onClick={onClick}>
                <DownloadIcon />
              </Box>
            )}
          />
          <Text
            as={Link}
            to={detailCommissionUrl(row.id)}
            style={{ cursor: "pointer", color: "#215AA8", fontWeight: 600, fontSize: "12px", lineHeight: "16px", borderRadius: "2px", border: "1px solid #215AA8", padding: "8px" }}
          >
            Detail
          </Text>
        </Flex>
      ),
    },
  ];

  const changePageHandler = (value) => {
    setPage(value.selected);
  };

  useEffect(() => {
    setPage(0);
  }, [periodStart, periodEnd]);

  useEffect(() => {
    setDataCommission(
      commissionManagement?.map?.((item, index) => ({
        ...item,
        communityCode: item.code,
        communityName: item.name,
        registeredDate: item.createdAt,
        status: !!item.isActive ? "Active" : "Non Active",
      })) || []
    );
  }, [commissionManagement]);

  return (
    <Box className="list-commission__container" paddingTop="24px" backgroundColor="#f8f8f9">
      <Box className="list-commission__content-container" narginTop="0">
        <Breadcrumb isStack title="List Commission" />

        <TotalCommissionActiveCommunityBanner amount={commissionManagementMeta?.totalCommission || 0} />

        <Box className="list-commission__container-filter" px="0" py="24px">
          <FilterListContent />
        </Box>

        {!isEmpty(dataCommission) ? (
          <ToolkitProvider
            key={search}
            data={dataCommission}
            keyField="communityCode"
            columns={columns}>
            {(props) => (
              <div className="pb-4 table-responsive list-commission__table-container">
                <BootstrapTable
                  {...props.baseProps}
                  bootstrap4={true}
                  bordered={false}
                  trStyle={{ backgroundColor: "white" }}
                />
              </div>
            )}
          </ToolkitProvider>
        ) : (
          <Text className="empty-state">There is no data entry</Text>
        )}
        {!isEmpty(dataCommission) && (
          <Pagination
            page={page}
            totalPage={totalPage}
            changePageHandler={changePageHandler}
          />
        )}
      </Box>
    </Box>
  );
}

export default navguard(ListCommission);
